





























































































































































































































// vue
import {
    defineComponent,
    onMounted,
    onUnmounted,
    ref,
} from '@vue/composition-api';

// services
import { useService } from '@/vue3/api/services';

// models
import { GeoRecord, GeoRecordCategorySummary } from '@/vue3/api/models';

// mapbox
import mapboxgl from 'mapbox-gl';
import * as turf from '@turf/turf';

// hooks
import store from '@/store';
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';
import { useGeometryHoverHook } from '@/vue3/hooks/geometryHoverHook';
import { useGeoRecordModify } from '@/vue3/hooks/geoRecordModifyHook';
import { useMeasureRecord } from '@/vue3/hooks/measureRecordHook';
import { useNotify } from '@/vue3/hooks/notifyHook';
import { useGeoRecordDelete } from '@/vue3/hooks/geoRecordDeleteHook';

// components
import GeoRecordEditor from '@/vue3/components/GeoRecordEditor.vue';
import GeoRecordEditorMobile from '@/vue3/components/GeoRecordEditorMobile.vue';
import MultiSelectTool from '@/vue3/components/geo-record-tools/MultiSelectTool.vue';
import ModifyGeometry from '@/vue3/components/geo-record-editor/ModifyGeometry.vue';
import Confirm from '@/vue3/components/Confirm.vue';
import { Portal } from '@linusborg/vue-simple-portal';
import LocationTool from '@/vue3/components/geo-record-tools/LocationTool.vue';

// primevue
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';
import Dialog from 'primevue/dialog';
import Listbox from 'primevue/listbox';
import Panel from 'primevue/panel';

// config
import geoRecordLayers from '@/vue3/configs/geoRecordLayers';
import Tools from '@/vue3/configs/selectToolConfig';

export default defineComponent({
    components: {
        GeoRecordEditor,
        Button,
        ProgressSpinner,
        Dialog,
        Listbox,
        Panel,
        MultiSelectTool,
        ModifyGeometry,
        Confirm,
        Portal,
        LocationTool,
        GeoRecordEditorMobile,
    },
    props: {
        mapbox: {
            type: Object,
            default: () => {},
        },
        setMapboxDrawSnap: {
            type: Function,
            default: () => {},
        },
        setMapboxElevation: {
            type: Function,
            default: () => {},
        },
        updateUtilityDrawerState: {
            type: Function,
            default: () => {},
        },
        setActiveTool: {
            type: Function,
            default: () => {},
        },
        utilityDrawer: {
            type: Object,
            default: null,
        },
        layerTree: {
            type: Object,
            default: null,
        },
    },
    setup(props: any, vm: any) {
        // services
        const {
            getGeoRecord,
            updateGeoRecord,
            getGeoRecordCategorySummaryByRole,
            categoriesToArray,
            getRole,
            createArchiveGeoRecord,
        } = useService();

        // hooks
        const {
            refreshGeoRecord,
            initSelectedGeoRecord,
            removeSelectedGeoRecord,
            updateGeoRecordExtrusion,
            refreshGeoRecordExtrusion,
            initMultiGeoRecordSource,
            removeCreateGeoRecordSource,
            removeVertexLabel,
            removeGeoRecordExtrusion,
            removeGeoRecord,
        } = useGeoRecord();

        const { deleteGeoRecordLayer } = useGeoRecordDelete();

        const { highlightGeometry, highlightGeoRecordExtrusions } =
            useGeometryHoverHook();

        const { updateModifiedGeoRecord, changeDateFormat } =
            useGeoRecordModify();

        const { successToast, warnToast, errorToast } = useNotify();

        const { calculateTotalMeasurement } = useMeasureRecord();

        // refs
        const isModifying = ref<boolean>(false);
        const isLoading = ref<boolean>(false);
        const isEditing = ref<boolean>(false);
        const isOverlayGeoRecordDialogVisible = ref<boolean>(false);
        const isMeasureRecordSelected = ref<boolean>(false);
        const isMultiToolSelected = ref<boolean>(false);
        const isMultipleGeomSelected = ref<boolean>(false);
        const isGeoRecordListCreated = ref<boolean>(false);
        const isModificationModeActive = ref<boolean>(false);
        const isDeleteActive = ref<boolean>(false);
        const isModifyAllowed = ref<boolean>(false);
        const isLocationTool = ref<boolean>(false);
        const isArchiveRecord = ref<boolean>(false);

        const activeToolName = ref<string>('');
        const activeToolDesc = ref<string>('');

        const selectedGeoRecordNames = ref<string[]>([]);

        const categorySummaries = ref<GeoRecordCategorySummary[]>([]);
        const geoRecordsArray = ref<GeoRecord[]>([]);

        const selectedGeoRecordId = ref<any>();
        const initialGeoRecordHeight = ref<any>();
        const geoRecordIdList = ref<any>([]);
        const tempFeatures = ref<any>([]);

        const uniqueFeatureIdArray = ref<any>([]);
        const geoRecordList = ref<any>([]);
        const filteredGeoRecord = ref<any>([]);
        const features = ref<any>([]);

        const role = ref();
        const activeTool = ref();
        const tempGeoRecord = ref();
        const selectedFeature = ref();
        const deleteGeoRecordRef = ref();

        const geoRecord = ref<GeoRecord>({
            id: 0,
            projectId: 0,
            archiveEventId: 0,
            title: ' ',
            images: [],
            height: null,
            area: null,
            length: null,
            perimeter: null,
            geoRecordCategoryId: 0,
        } as GeoRecord);

        // methods
        const setGeoRecordDefaultValue = () => {
            geoRecord.value = {
                id: 0,
                projectId: 0,
                title: ' ',
                images: [],
                height: null,
                area: null,
                length: null,
                perimeter: null,
                geoRecordCategoryId: 0,
            } as GeoRecord;
        };
        const toggleModifyToolVisibility = () => {
            isModificationModeActive.value = true;
            removeSelectedGeoRecord(props.mapbox.map, selectedFeature.value);
        };

        const activateModificationMode = () => {
            isModificationModeActive.value = true;
            removeSelectedGeoRecord(props.mapbox.map, selectedFeature.value);
        };

        const getFeatureDetails = async (feature: any) => {
            selectedFeature.value = feature;
            if (!store.state.isMobile) {
                // props.utilityDrawer.isUtilityOpen = true;
                props.updateUtilityDrawerState(true);
            }
            refreshExtrusion();

            setGeoRecord(feature.id, feature.geometry.type);

            if (!props.mapbox.map.getSource('selected-geo-records')) {
                initSelectedGeoRecord(props.mapbox.map, feature);
            }

            props.mapbox.map.setFeatureState(
                {
                    source: 'geo-records',
                    id: feature.id,
                },
                {
                    selected: true,
                },
            );

            props.mapbox.map.setFeatureState(
                {
                    source: 'geo-records',
                    id: geoRecord.value.id,
                },
                {
                    selected: false,
                },
            );
        };

        const checkIsModified = (): void => {
            isModifying.value = false;

            if (geoRecord.value.geoRecordCategoryId === 0) {
                isModifyAllowed.value = true;
                return;
            }

            for (vm of role.value.roleGeoRecordCategoryPermissionsLink) {
                if (vm.id === geoRecord.value.geoRecordCategoryId) {
                    if (vm.canEdit) {
                        isModifyAllowed.value = true;
                    } else {
                        isModifyAllowed.value = false;
                    }
                    break;
                } else {
                    isModifyAllowed.value = false;
                }
            }
        };

        const setGeoRecord = async (id?: number, type?: string) => {
            setIsModifying(false);
            isLoading.value = true;

            if (id && type) {
                tempGeoRecord.value = await getGeoRecord(id);
                initialGeoRecordHeight.value = tempGeoRecord.value.height;
                tempGeoRecord.value = await calculateTotalMeasurement(
                    tempGeoRecord.value,
                    type,
                );

                if (
                    tempGeoRecord.value.labelState === 'auto' ||
                    !tempGeoRecord.value.labelState ||
                    tempGeoRecord.value.labelState === 'on'
                ) {
                    tempGeoRecord.value.labelState = 'on';
                } else {
                    tempGeoRecord.value.labelState = 'off';
                }

                geoRecord.value = tempGeoRecord.value;
                geoRecord.value = changeDateFormat(geoRecord.value);

                checkIsModified();

                isEditing.value = true;
            } else {
                refreshExtrusion();
                setGeoRecordDefaultValue();
            }

            isLoading.value = false;
        };

        const saveGeoRecord = async () => {
            geoRecord.value = updateModifiedGeoRecord(
                props.mapbox.draw,
                geoRecord.value,
                categorySummaries.value,
            );

            if (!geoRecord.value.archiveEventId) {
                await updateAndRefreshGeoRecord();
            }

            if (geoRecord.value.archiveEventId && isArchiveRecord.value) {
                await confirmMoveRecordToArchive();
            }

            props.mapbox.draw.changeMode('simple_select');
            await props.layerTree.refreshGeoRecordTreeAndState(
                geoRecord.value,
                true,
            );

            isLoading.value = false;
        };

        const resetGeoRecord = async () => {
            props.mapbox.draw.delete('test');
            tempGeoRecord.value = await getGeoRecord(geoRecord.value.id);
            geoRecord.value = tempGeoRecord.value;

            removeSelectedGeoRecord(props.mapbox.map, tempGeoRecord.value);
            refreshGeoRecordExtrusion(props.mapbox.map, tempGeoRecord.value);
            refreshGeoRecord(props.mapbox.map, tempGeoRecord.value, true);
        };

        const moveGeoRecordToArchive = async (geoRecord: any) => {
            await createArchiveGeoRecord(geoRecord);

            successToast(
                `Geo Record: '${geoRecord.title}' successfully archived.`,
            );

            isModificationModeActive.value = false;
            isEditing.value = false;

            removeSelectedGeoRecord(props.mapbox.map, geoRecord);
            removeGeoRecordExtrusion(props.mapbox.map, geoRecord);
            removeGeoRecord(props.mapbox.map, geoRecord);
        };

        const updateAndRefreshGeoRecord = async () => {
            isLoading.value = true;
            let updatedGeoRecord;

            if (geoRecord.value.imageSrc) {
                geoRecord.value.imageSrc.forEach((img) => {
                    img.modifyDate = new Date(img.modifyDate).toISOString();
                });
            }

            try {
                const res = await updateGeoRecord(geoRecord.value, false);
                if (res.status == 200 || res.status == 201) {
                    updatedGeoRecord = res.data;
                    await getGeoRecordDetail(updatedGeoRecord.id);
                    updatedGeoRecord = geoRecord.value;

                    successToast(
                        `Geo Record: '${updatedGeoRecord.title}' saved.`,
                        store.state.isMobile ? 'fullscreen' : 'default',
                    );

                    initialGeoRecordHeight.value = updatedGeoRecord.height;
                    updateGeoRecordExtrusion(
                        props.mapbox.map,
                        updatedGeoRecord,
                    );
                    refreshGeoRecordExtrusion(
                        props.mapbox.map,
                        updatedGeoRecord,
                    );
                    refreshGeoRecord(props.mapbox.map, updatedGeoRecord, true);
                    changeDateFormat(updatedGeoRecord);

                    geoRecord.value = await calculateTotalMeasurement(
                        updatedGeoRecord,
                        updatedGeoRecord.geometry.type,
                    );
                } else {
                    errorToast(res.data);
                    throw `${res.data}`;
                }
            } catch (error) {
                console.log(error);
                await resetGeoRecord();
                return;
            }

            clearGeoRecordSelection();

            isLoading.value = false;
        };

        const confirmMoveRecordToArchive = async () => {
            try {
                await moveGeoRecordToArchive(geoRecord.value);
                await props.layerTree.refershArchiveGeoRecordLayerTree();
                await props.layerTree.fetchArchiveEvents();
                isArchiveRecord.value = false;
            } catch (error) {
                console.log(error);
                await resetGeoRecord();
                return;
            }
        };

        const toggleIsArchive = (value: boolean) => {
            isArchiveRecord.value = value;
        };

        const declineArchiveMove = (): void => {
            isArchiveRecord.value = false;
        };

        const clearGeoRecordSelection = async () => {
            if (geoRecord.value.id !== 0)
                removeSelectedGeoRecord(props.mapbox.map, geoRecord.value);

            isEditing.value = false;
            props.mapbox.draw.changeMode('simple_select');
            props.mapbox.draw.deleteAll();

            setIsModifying(false);
            refreshExtrusion();

            geoRecord.value = {
                id: 0,
                projectId: 0,
                title: '',
                images: [],
                height: null,
                geoRecordCategoryId: 0,
            } as GeoRecord;

            isModificationModeActive.value = false;
            isArchiveRecord.value = false;
        };

        const toolUnmounted = () => {
            if (geoRecord.value.id !== 0) {
                clearGeoRecordSelection();
                refreshGeoRecord(props.mapbox.map, geoRecord.value, true);
                refreshExtrusion();
            }

            deActivateMouseMove();
            props.mapbox.draw.deleteAll();
            props.mapbox.draw.changeMode('simple_select');
        };

        const discardModify = () => {
            removeVertexLabel(props.mapbox.map, props.mapbox.draw.get('test'));
            props.mapbox.draw.changeMode('simple_select');
            props.mapbox.draw.delete('test');

            if (props.mapbox.map.getSource('selected-geo-records')) {
                removeSelectedGeoRecord(props.mapbox.map, geoRecord.value);
            }

            initSelectedGeoRecord(props.mapbox.map, geoRecord.value);
            refreshGeoRecordExtrusion(props.mapbox.map, geoRecord.value);

            isEditing.value = true;
        };

        const setIsModifying = (value: boolean) => {
            isModifying.value = value;
            refreshExtrusion();

            if (!value) {
                props.mapbox.draw.changeMode('simple_select');
                refreshGeoRecord(props.mapbox.map, geoRecord.value, true);
                activateMouseMove();
            } else {
                deActivateMouseMove();
                removeSelectedGeoRecord(props.mapbox.map, geoRecord.value);
            }
        };

        const refreshExtrusion = () => {
            if (geoRecord.value.id !== 0) {
                geoRecord.value.height = initialGeoRecordHeight.value;

                updateGeoRecordExtrusion(props.mapbox.map, geoRecord.value);
                refreshGeoRecordExtrusion(props.mapbox.map, geoRecord.value);
            }
        };

        const hoverExtrusion = (e) => {
            if (props.mapbox.map.getLayer('polygon-extrusion')) {
                highlightGeoRecordExtrusions(
                    e,
                    props.mapbox.map,
                    'polygon-extrusion',
                );
            }
        };

        const saveAllGeoRecords = async (geoRecord: any) => {
            try {
                await updateGeoRecord(geoRecord, false);
            } catch (error) {
                window.console.log(error);
                cancelSelectByMultiTool();
                props.mapbox.draw.deleteAll();
                return;
            }

            successToast(`Multiple Geo Records saved.`);

            removeSelectedGeoRecord(props.mapbox.map, geoRecord);
            refreshGeoRecordExtrusion(props.mapbox.map, geoRecord);
            refreshGeoRecord(props.mapbox.map, geoRecord, true);
            clearGeoRecordSelection();
            cancelSelectByMultiTool();
        };

        const getGeoRecordDetails = async (feature: any) => {
            if (
                !geoRecordsArray.value.some(
                    (geoRecord) => geoRecord.id === feature[0].id,
                )
            ) {
                selectedGeoRecordNames.value.push(feature[0].properties);
                geoRecordsArray.value.push(await getGeoRecord(feature[0].id));

                isGeoRecordListCreated.value = true;

                initMultiGeoRecordSource(
                    props.mapbox.map,
                    geoRecordsArray.value,
                );
            }
        };

        const getGeoRecordDetail = async (id: any) => {
            geoRecord.value = await getGeoRecord(id);
            if (!store.state.isMobile) {
                // props.utilityDrawer.isUtilityOpen = true;
                props.updateUtilityDrawerState(true);
            }
        };

        const onGeoRecordSelected = async () => {
            if (
                selectedGeoRecordId.value !== undefined &&
                selectedGeoRecordId.value !== null
            ) {
                geoRecordList.value.forEach((element: any) => {
                    if (element.id === selectedGeoRecordId.value) {
                        isOverlayGeoRecordDialogVisible.value = false;
                        filteredGeoRecord.value = element;
                    }
                });

                deleteGeoRecordRef.value = filteredGeoRecord.value;

                activeToolName.value === 'Delete Tool'
                    ? checkEditPermission(filteredGeoRecord.value)
                    : await getFeatureDetails(filteredGeoRecord.value);
            }
        };

        const confirmDeleteCallback = async (): Promise<void> => {
            isLoading.value = true;

            try {
                await deleteGeoRecordLayer(
                    props.mapbox.map,
                    deleteGeoRecordRef.value,
                );

                removeGeoRecordExtrusion(
                    props.mapbox.map,
                    deleteGeoRecordRef.value,
                );

                let georecordArry = [props.value.id];

                await props.layerTree.refreshGeoRecordTreeAndState(
                    georecordArry,
                    false,
                );

                successToast(`Geo Record deleted.`);
            } catch (error) {
                console.log(error);
                warnToast('Cannot delete Geo Record');
                isLoading.value = false;
            }

            isDeleteActive.value = false;

            isLoading.value = false;
        };

        const declineDeleteCallback = () => {
            isDeleteActive.value = false;
        };

        const checkEditPermission = (geoRecord): void => {
            for (vm of role.value.roleGeoRecordCategoryPermissionsLink) {
                if (vm.id === geoRecord.properties.geoRecordCategoryId) {
                    if (vm.canEdit) {
                        isDeleteActive.value = true;
                    } else {
                        isDeleteActive.value = false;
                    }
                    break;
                } else {
                    isDeleteActive.value = false;
                }
            }

            if (!isDeleteActive.value) {
                errorToast('Permission Denied - Unable to delete Geo Record.');
            }
        };

        const popup = new mapboxgl.Popup({
            closeButton: false,
            className: 'pop-up',
        });

        const airTableRecords = (feature: any): void => {
            const coordinates = feature.geometry.coordinates.slice();
            const description = feature.properties.description;

            popup
                .setLngLat(coordinates)
                .setHTML(description)
                .addTo(props.mapbox.map);
        };

        const onGeoRecordClicked = async (e: any, isLayerTree: boolean) => {
            features.value = props.mapbox.map.queryRenderedFeatures(e.point);

            features.value.forEach((feature: any) => {
                if (geoRecordList.value.id !== feature.id) {
                    geoRecordList.value = [];
                    clearGeoRecordSelection();
                }
            });

            if (isModifying.value) {
                return;
            }

            if (isLayerTree) {
                // props.utilityDrawer.isUtilityOpen = true;
                if (!store.state.isMobile) {
                    props.updateUtilityDrawerState(true);
                }
                isOverlayGeoRecordDialogVisible.value = false;
                getFeatureDetails(e);
                return;
            }

            features.value.forEach((feature: any) => {
                if (feature.source == 'measure-records') {
                    isMeasureRecordSelected.value = true;
                } else if (feature.source == 'air-table-records') {
                    airTableRecords(feature);
                    return;
                }
            });

            if (isMeasureRecordSelected.value) {
                warnToast(`Measure Records cannot be selected.`);
                isMeasureRecordSelected.value = false;
                return;
            }

            features.value = features.value.filter(function (feature) {
                return feature.source == 'geo-records';
            });

            if (!features.value[0]) {
                isEditing.value = false;
                return;
            }

            if (features.value.length !== 0) {
                tempFeatures.value = [];
                geoRecordIdList.value = [];
                selectedGeoRecordId.value = null;

                features.value.forEach((feature) => {
                    tempFeatures.value.push(feature.id);
                });

                uniqueFeatureIdArray.value = [...new Set(tempFeatures.value)];

                uniqueFeatureIdArray.value = uniqueFeatureIdArray.value.filter(
                    (item) => item !== undefined,
                );

                uniqueFeatureIdArray.value.forEach((id) => {
                    const feature = features.value.find(
                        (feature) => feature.id === id,
                    );
                    if (feature) {
                        geoRecordIdList.value.push({
                            id: feature.id,
                            name: feature.properties.title,
                        });
                        geoRecordList.value.push(feature);
                    }
                });

                if (geoRecordIdList.value.length > 1) {
                    isOverlayGeoRecordDialogVisible.value = true;
                } else if (geoRecordIdList.value.length === 1) {
                    if (e.type === 'contextmenu') {
                        await getGeoRecordDetail(geoRecordList.value[0].id);
                        checkIsModified();
                        activateModificationMode();
                        return;
                    }

                    isOverlayGeoRecordDialogVisible.value = false;

                    deleteGeoRecordRef.value = geoRecordList.value[0];

                    activeToolName.value === 'Delete Tool'
                        ? checkEditPermission(geoRecordList.value[0])
                        : getFeatureDetails(geoRecordList.value[0]);
                }

                if (store.state.isMobile) {
                    // props.utilityDrawer.isUtilityOpen = false;
                    props.updateUtilityDrawerState(false);
                    const feature = geoRecordList.value[0];
                    let center;

                    if (feature.geometry.type === 'Point') {
                        center = feature.geometry.coordinates;
                    } else {
                        const centroid = turf.centroid(feature);
                        center = centroid.geometry?.coordinates;
                    }

                    const offset =
                        window.innerWidth > 500 && window.innerWidth < 1024
                            ? -0.001
                            : -0.003;

                    props.mapbox.map.flyTo({
                        center: [center[0], center[1] + offset],
                        zoom: 15,
                    });
                }

                props.utilityDrawer.setUtilityTabIndex(0);
            } else {
                isEditing.value = false;

                if (e.type === 'contextmenu') {
                    props.mapbox.draw.delete('test');
                }
            }
        };

        const onMultiGeoRecordClick = (e: any) => {
            isDeleteActive.value = false;
            isMultipleGeomSelected.value = false;

            features.value = props.mapbox.map.queryRenderedFeatures(e.point);
            features.value = features.value.filter(function (feature) {
                return feature.source == 'geo-records';
            });

            tempFeatures.value = [
                ...new Map(
                    features.value.map((item) => [item.id, item]),
                ).values(),
            ];

            if (tempFeatures.value.length > 0) {
                getGeoRecordDetails([...tempFeatures.value]);
            }
        };

        const onMouseMove = (e) => {
            highlightGeometry(e, props.mapbox.map, 'geo-records');
        };

        const activateMouseMove = () => {
            props.mapbox.map.on('mousemove', hoverExtrusion);

            geoRecordLayers.forEach((geoRecordLayer) => {
                props.mapbox.map.on(
                    'mousemove',
                    geoRecordLayer.id,
                    onMouseMove,
                );

                props.mapbox.map.on(
                    'mouseleave',
                    geoRecordLayer.id,
                    onMouseMove,
                );
            });
        };

        const deActivateMouseMove = () => {
            props.mapbox.map.off('mousemove', hoverExtrusion);

            geoRecordLayers.forEach((geoRecordLayer) => {
                props.mapbox.map.off(
                    'mousemove',
                    geoRecordLayer.id,
                    onMouseMove,
                );

                props.mapbox.map.off(
                    'mouseleave',
                    geoRecordLayer.id,
                    onMouseMove,
                );
            });
        };

        const cancelSelectByMultiTool = () => {
            geoRecordsArray.value = [];
            selectedGeoRecordNames.value = [];
            isGeoRecordListCreated.value = false;

            clearGeoRecordSelection();
            removeCreateGeoRecordSource(props.mapbox.map);

            if (isMultiToolSelected.value) {
                props.mapbox.map.on('click', onMultiGeoRecordClick);
            }
        };

        const toolClick = (tool) => {
            activeTool.value = tool;
            activeToolName.value = tool.name;
            activeToolDesc.value = tool.description;

            if (tool.name === 'Select Tool') {
                removeCreateGeoRecordSource(props.mapbox.map);

                props.mapbox.map.on('dragstart', onMobileDragStart);
                props.mapbox.map.on('dragend', onMobileDragEnd);
                props.mapbox.map.on('click', onGeoRecordClicked);
                props.mapbox.map.on('touchend', onGeoRecordClicked);
                props.mapbox.map.on('contextmenu', onGeoRecordClicked);

                isMultiToolSelected.value = false;
                isLocationTool.value = false;

                cancelSelectByMultiTool();
            } else if (tool.name === 'Multi Select Tool') {
                props.mapbox.map.off('click', onGeoRecordClicked);
                props.mapbox.map.off('contextmenu', onGeoRecordClicked);

                isMultiToolSelected.value = true;
                isLocationTool.value = false;

                props.mapbox.draw.deleteAll();
            } else if (tool.name === 'Location Tool') {
                isLocationTool.value = true;
                props.mapbox.map.off('click', onGeoRecordClicked);
                props.mapbox.map.off('dragstart', onMobileDragStart);
                props.mapbox.map.off('dragend', onMobileDragEnd);
                props.mapbox.map.off('touchend', onGeoRecordClicked);
                props.mapbox.map.off('contextmenu', onGeoRecordClicked);

                isMultiToolSelected.value = false;

                cancelSelectByMultiTool();
            } else {
                props.mapbox.map.on('click', onGeoRecordClicked);
                props.mapbox.map.off('contextmenu', onGeoRecordClicked);
                props.mapbox.map.off('click', onMultiGeoRecordClick);
                props.mapbox.map.on('touchend', onGeoRecordClicked);

                isMultiToolSelected.value = false;
                isLocationTool.value = false;

                cancelSelectByMultiTool();
            }
        };

        const initPopUp = (): void => {
            popup.value = new mapboxgl.Popup({
                closeButton: false,
                maxWidth: '320px',
            });
        };

        const onMobileDragStart = () => {
            props.mapbox.map.off('touchend', onGeoRecordClicked);
        };

        const onMobileDragEnd = () => {
            props.mapbox.map.on('touchend', onGeoRecordClicked);
        };

        const turnOffMouseEvents = () => {
            props.mapbox.map.off('click', onGeoRecordClicked);
            props.mapbox.map.off('touchend', onGeoRecordClicked);
            props.mapbox.map.off('dragstart', onMobileDragStart);
            props.mapbox.map.off('dragend', onMobileDragEnd);
            props.mapbox.map.off('contextmenu', onGeoRecordClicked);
            props.mapbox.map.off('click', confirmDeleteCallback);
        };

        const setRoleValue = async (): Promise<void> => {
            isLoading.value = true;
            role.value = await getRole(store.getters.account.roleId);
            isLoading.value = false;
        };

        const updateGeoRecordExternal = (newValue: any) => {
            geoRecord.value = newValue;
        };

        // lifecycle
        onMounted(async () => {
            await setRoleValue();
            toolClick(Tools[0]);
            activateMouseMove();
            setGeoRecordDefaultValue();
            initPopUp();

            categorySummaries.value = categoriesToArray(
                await getGeoRecordCategorySummaryByRole(),
            );
        });

        onUnmounted(() => {
            toolUnmounted();
            deActivateMouseMove();
            turnOffMouseEvents();
        });

        return {
            store,
            isEditing,
            geoRecord,
            updateGeoRecordExternal,
            clearGeoRecordSelection,
            saveGeoRecord,
            isLoading,
            isModifying,
            setIsModifying,
            discardModify,
            categorySummaries,
            isOverlayGeoRecordDialogVisible,
            selectedGeoRecordId,
            geoRecordIdList,
            onGeoRecordSelected,
            onGeoRecordClicked,
            Tools,
            role,
            toolClick,
            activeToolName,
            activeToolDesc,
            isMultiToolSelected,
            selectedGeoRecordNames,
            isMultipleGeomSelected,
            isGeoRecordListCreated,
            updateAndRefreshGeoRecord,
            geoRecordsArray,
            toggleModifyToolVisibility,
            isModificationModeActive,
            isDeleteActive,
            confirmDeleteCallback,
            declineDeleteCallback,
            isModifyAllowed,
            isLocationTool,
            moveGeoRecordToArchive,
            isArchiveRecord,
            declineArchiveMove,
            toggleIsArchive,
        };
    },
});
